<div class="grid grid-cols-4 gap-3">
  @for (option of options; track option.platformFeature) {
    <button
      type="button"
      class="platform-step-card"
      matTooltipPosition="above"
      [attr.aria-pressed]="form.controls.platformFeature.value === option.platformFeature"
      [class.platform-step-card-selected]="form.controls.platformFeature.value === option.platformFeature"
      [matTooltip]="unsupportedTooltipByPlatformFeature()[option.platformFeature] ?? ''"
      (click)="onPlatformSelected(option.platformFeature)"
    >
      <app-social-badge
        color="var(--shikenso-base-white)"
        [type]="option.platformFeature"
        [size]="32"
        [iconSize]="16"
        [borderRadius]="8"
      />
      <span class="text-sm">
        {{ 'shared.platformFeatures.' + option.platformFeature | translate }}
      </span>
    </button>
  }
</div>

<mat-error class="custom-mat-error" [control]="form.controls.platformFeature" />
